import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';

const Gender = ({ gender, setGender, required }) => {

    const { t } = useTranslation("register")

    const handleChange = (event) => {
        setGender(event.target.value);
    };

    return (
        <div>
            <FormControl size="small" fullWidth>
                <InputLabel>{t("gender")}</InputLabel>
                <Select
                    value={gender}
                    onChange={handleChange}
                    label={t("gender")}
                    required={required}
                >
                    <MenuItem value={1}>{t("male")}</MenuItem>
                    <MenuItem value={2}>{t("female")}</MenuItem>
                </Select>
            </FormControl>
        </div>
    )
}

export default Gender;